import { render, staticRenderFns } from "./ArtisanNumber.vue?vue&type=template&id=10171573"
import script from "./ArtisanNumber.vue?vue&type=script&lang=js"
export * from "./ArtisanNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports